<template>
  <div>
    <PageAllow
      controller="Shops"
      action="shopBalanceSnapshots"
      :prohibit="settings && !settings.shop_balance_snapshot_time"
    />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRange
                type="datetime"
                v-model="datetimeRage"
                :label="$t('StockMaterialHistories.Fields.created_time')"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 批量导出 -->
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'Shops',
                    'shopBalanceSnapshotExport'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="batchExportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("StockMaterialHistories.Fields.batchDetailExport") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherShops v-model="shopsSelected" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistrictsWithDescendants v-model="districtsSelected"
                /></v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="shop_balance_snapshots"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:item.created="{ item }">
              <span>
                {{ item.created | formatTime }}
              </span>
            </template>
            <template v-slot:item.balance="{ item }">
              <span>
                {{ $t("Global.money") }}{{ item.balance | formatMoney }}
              </span>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import Shops from "@/api/shops";
import consts from "@/consts";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  shop_ids: [],
  district_codes: [],
};

export default {

  data: () => ({
    shop_balance_snapshots: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("shop-balance-snapshots-options")
        ? sessionStorage.getItem("shop-balance-snapshots-options")
        : JSON.stringify(defaultOptions)
    ),
    datetimeRage: [
      new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    shopsSelected: [],
    districtsSelected: [],
  }),

  components: {
    Breadcrumbs,
    SearcherDatetimeRange,
    PageAllow,
    SearcherShops,
    SearcherDistrictsWithDescendants,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.capital"),
        disabled: true,
        href: "/capital",
      },
      {
        text: i18n.t("capital.shopBalanceSnapshots"),
        disabled: true,
        href: "",
      },
    ],
    headers: () => [
      {
        text: i18n.t("capital.Fields.shop_name", [consts.shopName()]),
        align: "start",
        sortable: false,
        value: "shop_name",
      },
      {
        text: i18n.t("capital.Fields.district_name"),
        align: "start",
        sortable: false,
        value: "district_name",
      },
      {
        text: i18n.t("capital.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("capital.Fields.balance"),
        align: "start",
        sortable: false,
        value: "balance",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("shop-balance-snapshots", [
        "shopsSelected",
        "districtsSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (
              typeof this.options.created_time_from != "undefined" &&
              typeof this.options.created_time_to != "undefined"
            )
              this.datetimeRage = [
                this.options.created_time_from,
                this.options.created_time_to,
              ];
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "districtsSelected":
                this.districtsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.shopsSelected = [];
      this.districtsSelected = [];
      this.datetimeRage = [
        new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getShopBalanceSnapshotsFromAPI() {
      Shops.getShopBalanceSnapshots(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shop_balance_snapshots = response.data.shop_balance_snapshots;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    batchExportExcel() {
      Shops.shopBalanceSnapshotExport(this.options);
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getShopBalanceSnapshotsFromAPI();
        sessionStorage.setItem(
          "shop-balance-snapshots-options",
          JSON.stringify(this.options)
        );
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((shop) => {``
              return shop.id;
            })
          : [];
        sessionStorage.setItem(
          "shop-balance-snapshots-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
    districtsSelected: {
      handler() {
        this.options.district_codes = this.districtsSelected
          ? this.districtsSelected.map((e) => {
              return e.code;
            })
          : [];
        sessionStorage.setItem(
          "shop-balance-snapshots-districtsSelected",
          JSON.stringify(this.districtsSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>